import React, { FC } from 'react';
import styles from './ErrorMessage.module.css';
import Alert from './Alert';
import Xsvg from './Xsvg';

interface ErrorProps {
  message: string;
  display: boolean;
  dismiss: (show: boolean) => void;
}

const ErrorMessage: FC<ErrorProps> = (errorProps: ErrorProps) => {
  const { message, display, dismiss } = errorProps;

  const imageClick = () => {
    dismiss(false);
  };

  return (
    display && (
      <div className={styles['type-open-radius']}>
        <div className={styles['alert-severity']}>
          <div className={styles.img}>
            <Alert />
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles['text-wrapper']}>{message}</div>
        </div>
        <div className={styles.img} onClick={() => imageClick()}>
          {' '}
          <Xsvg />{' '}
        </div>
      </div>
    )
  );
};

export default ErrorMessage;
